import React from 'react';
import { ChevronRight, Loader } from 'lucide-react';

const MetaAssetsLoadingState = ({ platform = 'meta' }) => {
  const isWhatsAppFlow = platform === 'whatsapp';

  return (
    <div className="w-full min-h-[40vh] lg:min-h-[46vh] flex items-start lg:items-center animate-in fade-in duration-300">
      <div className="w-full rounded-[28px] bg-slate-950/90 border border-white/20 p-4 sm:p-6 lg:p-8 text-white shadow-2xl backdrop-blur-md">
        <div className="mx-auto w-full max-w-3xl">
          <div className="mb-6 lg:mb-8 text-center">
            <h1 className="text-2xl lg:text-3xl font-bold mb-2">
              {isWhatsAppFlow ? 'Configurar WhatsApp' : 'Configurar Activos de Meta'}
            </h1>
            <p className="text-white/65 text-sm lg:text-base">
              {isWhatsAppFlow
                ? 'Seleccioná la página de Facebook, la cuenta de Instagram y el número de WhatsApp Business para tus campañas.'
                : 'Selecciona la página de Facebook y la cuenta de Instagram para tus campañas de Meta Ads.'}
            </p>
          </div>

          <div className="min-h-[260px] flex flex-col items-center justify-center py-8 space-y-3">
            <Loader className="w-8 h-8 text-white animate-spin" />
            <p className="text-white/70">Cargando configuración de activos de Meta...</p>
          </div>

          <div className="flex gap-3">
            <button
              disabled
              className="flex-1 px-4 py-3 bg-white/10 text-white/70 font-medium rounded-lg border border-white/20 cursor-not-allowed"
            >
              Atrás
            </button>

            <button
              disabled
              className="flex-1 px-4 py-3 bg-gradient-to-r from-blue-600/70 to-blue-700/70 text-white/70 font-medium rounded-lg flex items-center justify-center gap-2 cursor-not-allowed"
            >
              Continuar
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaAssetsLoadingState;
